// extracted by mini-css-extract-plugin
export default {"primaryColor":"#fff","secondaryColor":"#1e1e24","complementaryColor":"#9f3636","aux":"#94722b","auxNeutral":"#9f3636"};